import React from "react";
import { Field, ErrorMessage } from "formik";
import { TextError } from "../TextError";
const RadioButton = (props) => {
  const { label, name, options, ...rest } = props;
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <Field as="" id={name} name={name} {...rest} className="form-control">
        {({ field }) => {
          return options.map((curr, index) => {
            return (
              <React.Fragment key={curr.key}>
                <br />
                <input
                  type="radio"
                  id={curr.value}
                  {...field}
                  value={curr.value}
                  checked={field.value === curr.value}
                />
                <label htmlFor={curr.value}>{curr.key}</label>
              </React.Fragment>
            );
          });
        }}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </>
  );
};

export default RadioButton;
